
interface DeliveryOrderProcessViewControllerDelegate
{
    processStockNotesWithComments( controller: DeliveryOrderProcessViewController );
}

class DeliveryOrderProcessViewController extends MUIViewController
{
    static newInstance():DeliveryOrderProcessViewController
    {
        let vc = new DeliveryOrderProcessViewController('delivery-order-process-view');
        vc.initWithResource("layout/delivery_order/DeliveryOrderProcessView.html");
        return vc;
    }
    
    get preferredContentSize() { return new MIOSize(800, 500); }

    delegate:DeliveryOrderProcessViewControllerDelegate = null;

    private closeButton:MUIButton = null;
    private sendButton:MUIButton = null;
    private tableView:UITableView = null;

    viewDidLoad()
    {
        this.closeButton = MUIOutlet(this, "close-btn", "MUIButton");
        this.closeButton.setAction(this, function(){
            this.dismissViewController(true);
        });

        this.sendButton = MUIOutlet(this, "send-btn", "MUIButton");
        // this.sendButton.setAction(this, this.sendAction);

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
    }

    viewWillAppear(animated?: boolean): void {
        super.viewWillAppear(animated);
        this.updateUI();
    }

    private _stockNote:StockNote = null;
    set stockNote (value:StockNote){
        this._stockNote = value;        
        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false || this._stockNote == null) return;
        this.mapProducts();
        this.tableView.reloadData();
    }

    numberOfRowsInSection(tableView:UITableView, section:number){
        return this._products.length;
    }

    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let item = this._products[indexPath.row];
        let identifier = "DeliveryOrderProcessCell" //item[ "Type" ] == 0 ? "PurchaseOrderTemplateCell" : "PurchaseOrderTemplateSubCell";

        let cell = tableView.dequeueReusableCellWithIdentifier(identifier) as DeliveryOrderProcessCell;
        // if (item[ "Type" ] == 0) cell.delegate = this;
        cell.item = item;
                
        return cell;
    }

    private product_ids:MIOSet = new MIOSet();
    private _products:any[]
    mapProducts(){
        this.product_ids = new MIOSet();
        let products_map = {};
        for (let index = 0; index < this._stockNote.lines.length; index++) {
            let line = this._stockNote.lines.objectAtIndex(index) as DeliveryOrderLine;
            let name = line.selectedProduct.name;
            let id = line.selectedProduct.identifier;
            let item = products_map[line.selectedProduct.identifier] ?? { "OrderPath": name, "Quantity": 0, "ID": id, "Name": name };
            item[ "Quantity" ] += line.productQuantity;
            products_map[line.selectedProduct.identifier] = item;

            this.product_ids.addObject( id );
        }

        this._products = Object.keys(products_map).map(key => products_map[key]);        
        this._products = _MIOSortDescriptorSortObjects( this._products, "OrderPath", true);
        this.tableView.reloadData();

        this.currentProductStock();
    }

    private currentProductStock() {
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.webService.currentStock(this.product_ids.allObjects, (data:any, error:string) => {
            if ( error == null || (error != null && error.length == 0) ) {
                this.mapCurrentStock(data);
            }
            else {
                AppHelper.showErrorMessage(null, "Error", "Couldn't get current stock. " + error);
            }
        });
    }

    private mapCurrentStock(data:any){
        for (let item of data) {
            if (item["Type"] != "table") continue;
            let rows = item["Rows"];
            for (let r of rows) {
                let id = r["product_id"].toUpperCase();
                let stock = r["start_qty"];
                for (let p of this._products) {
                    if (p["ID"] == id) {
                        p["StockQuantity"] = stock;
                        break;
                    }
                }
            }
        }
        this.tableView.reloadData();
        this.anotherOrders();
    }

    private anotherOrders(){
        DBHelper.queryObjectsWithCompletion( "DeliveryOrderLine", null, MIOPredicate.predicateWithFormat( "note.identifier != '" + this._stockNote.identifier + "' && note.status = 1 && deletedAt = null && selectedProduct.identifier IN ['" + this.product_ids.allObjects.join("','") + "']" ), ["selectedProduct"], this, function(this:DeliveryOrderProcessViewController, lines:DeliveryOrderLine[]){    
            for (let l of lines) {
                let id = l.selectedProduct.identifier;
                let stock = l.productQuantity;
                for (let p of this._products) {
                    if (p["ID"] == id) {
                        if (p["PendingQuantity"] == null) p["PendingQuantity"] = 0; 
                        p["PendingQuantity"] += stock; 
                        break; }
                }
            }
            
            // Put defaults
            for (let p of this._products) {                
                if (p["PendingQuantity"] == null) p["PendingQuantity"] = 0; 
            }

            this.tableView.reloadData();
        });
    }
}